import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

// Translation provided by Vuetify (javascript)
import fa from 'vuetify/lib/locale/fa'
import en from 'vuetify/lib/locale/en'

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  lang: {
    locales: { fa, en },
    current: 'fa',
  },
  rtl: true,
  theme: {
    // dark: true,
    themes: {
      light: {
        primary: '#272161',
        accent: '#fcc401',
        secondary: colors.grey.darken1,
        error: '#ff493d',
        background: '#fafafa',
        mission: colors.deepPurple,
        vacation: colors.lightBlue,
        io: colors.teal,
        extrawork: colors.pink,
        red: '#ffb4b4',
        green: '#9cf4dc',
      },
      dark: {
        primary: '#646172',
        accent: '#fcc401',
        error: '#ff443d',
        background: '#38383D',
        secondary: '#f2f2f2',
        mission: colors.deepPurple,
        vacation: colors.lightBlue,
        io: colors.teal,
        extrawork: colors.pink,
        red: '#ffb4b4',
        green: '#9cf4dc',
      },
    },
  },
});
